import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
//import { Videocam,PhotoCamera} from '@material-ui/icons';
import Videocam from './img/btn-modevideo-on-normal.png';
import PhotoCamera from './img/btn-modecamera-on-normal.png';
import Toolbar from '@material-ui/core/Toolbar';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Slide from '@material-ui/core/Slide';
import classNames from 'classnames';
import { I18n } from 'aws-amplify';

import ThetaImageMenu from './ThetaImageMenu';
import ThetaVideoMenu from './ThetaVideoMenu';
import ThetaVideoStatusMenu from './ThetaVideoStatusMenu';
import ThetaSlider from './ThetaSlider';
import moment from 'moment-timezone';
import "./plugin.css";
import "./../smartdevice.css";
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  indicator: {
    backgroundColor: 'transparent',
  },
  finish_button:{
    display:'inline',
    marginRight: '90%',
    fontSize: 'medium',
    marginTop:'8px',
  }
})

const takePicture = { name:'camera.takePicture'};
const startCapture = { name:'camera.startCapture'};
const stopCapture = { name:'camera.stopCapture'};
const setImage = { 
  name: 'camera.setOptions',
  parameters: {
    options: {
      captureMode: 'image'
    }
  }
};

const setVideo = { 
  name: 'camera.setOptions',
  parameters: {
    options: {
      captureMode: 'video'
    }
  }
};

let setOptions = { 
	  name: 'camera.setOptions',
	  parameters: {}
};

let exposureDelay = {
    exposureProgram: 2,
    exposureProgramTitle: 'auto',
    exposureProgramIcon: 'btn--mode-auto-normal',
    auto:{
      exposureCompensation: '-2',
      _filter: 'off',
      _filterText: 'OFF'
    },
    shutter:{
      shutterSpeed: '0.00004',
      shutterSpeedText: '1/25000',
      exposureCompensation: '-2',
      whiteBalance: 'auto',
      whiteBalanceIcon: 'icon--wb_auto'
    },
    iso:{
      iso: '64',
      exposureCompensation: '-2',
      whiteBalance: 'auto',
      whiteBalanceIcon: 'icon--wb_auto'
    },
    manual:{
      aperture: '2.1',
      iso: '64',
      shutterSpeed: '0.00004',
      shutterSpeedText: '1/25000',
      whiteBalance: 'auto',
      whiteBalanceIcon: 'icon--wb_auto'
    },
    aperture:{
        aperture: '2.1',
        whiteBalance: 'auto',
        whiteBalanceIcon: 'icon--wb_auto',
        exposureCompensation: '-2'
    }
  };

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 2 }}>
      {props.children}
    </Typography>
  );
}

class ThetaShooting extends React.Component {
  timer = null;

  state = {
    value: 0,
    loading: false,
    open: false,
    videoOptions: undefined,
    options:{
      captureMode: 'image',
      image: exposureDelay,
      video: exposureDelay
    }
  };

  componentDidMount() {
    let timezone = moment.tz.guess();
    setOptions.parameters.options={
      // eslint-disable-next-line
      dateTimeZone: '"' + moment().tz(timezone).format("YYYY:MM:DD HH:mm:ssZ") + '"'
    };
    this.props.onShootingPostDate(this.props.devicename,setOptions);
    
    //this.props.onShootingPostDate(this.props.serialnumber,getLivePreview);
  }

  componentWillReceiveProps(nextProps) {
    let _options = this.state.options;
    let _videoOptions = this.state.videoOptions;
    let _value = this.state.value;
    
    if (nextProps.getOptions !== undefined) {
      _options = nextProps.getOptions;
      if (nextProps.getOptions.captureMode === 'video') {
        _value = 1;
      }
    }
    
    this.startTimer();

    //if (nextProps.videoJsOptions !== undefined) {
    //  _videoOptions = nextProps.videoJsOptions;
    //  if (_videoOptions.sources[0].src.length === 0) {
    //    this.props.onGetPreviewURL(this.props.serialnumber);
    //  }
    //}
    this.setState({
      value: _value,
      videoOptions: _videoOptions,
      options: _options
    });
  }    
  
  componentWillUnmount() {
    //this.props.onShootingPostDate(this.props.serialnumber,stopLivePreview);

    clearTimeout(this.timer);

    if (this.state.loading) {
      this.props.onShootingPostDate(this.props.devicename,stopCapture);
    }
  }

  updateState(state){
    if (state.options.command !== undefined) {
      this.startTimer();
      this.props.onShootingPostDate(this.props.devicename,state.options.command);
    }

    this.setState(state);
    //親コンポーネントを更新
  }

  getOption(props) {
      props.onShootingMount(props.devicename);
  };
  
  startTimer() {
    clearInterval(this.timer);
    this.timer = setInterval(this.getOption, 3000,this.props);
  }

  handleClickLoading = (devicename,value, loading) => {
    let _options = this.state.options;
    if (value === 1) {
      if (loading) {
        this.props.onShootingPostDate(devicename,stopCapture);
      } else {
        this.props.onShootingPostDate(devicename,startCapture);
        _options.captureStatus = 'shooting'
        this.startTimer();
      }
      this.setState({
        loading: !this.state.loading,
        commands: takePicture
      });
    } else if (value === 2) {
      // this.props.onShootingPostDate(this.props.serialnumber,getLivePreview);
    } else {
      this.props.onShootingPostDate(devicename,takePicture);
      _options.captureStatus = 'shooting'
      this.startTimer();
    }
    this.setState({
      options: _options
    });
  };

  handleChange = (event, value) => {
    let _options = this.state.options;

    if (value === 1) {
      this.props.onShootingPostDate(this.props.devicename,setVideo);
      _options.captureMode = 'video';
    } else {
      this.props.onShootingPostDate(this.props.devicename,setImage);
      _options.captureMode = 'image';
    }
    this.setState({
      value,
      options: _options
    });
  };
  
  selectClick = (open) => {
    const _options = this.state.options;
    open = _options.exposureProgramOpen?false:true;
    _options.exposureProgramOpen = open;
    
    clearTimeout(this.timer);
    this.setState({ 
      options: _options
    });
  };
  
  isPowerDown(options) {
    if (options.power !== undefined && options.power === 'off') {
      return true;
    }
    return false;
  }
  
  isShooting(options) {
    if (options.captureStatus !== undefined && options.captureStatus === 'shooting') {
      return true;
    }
    return false;
  }
  
  isActionAuto(options) {
    let filter = undefined
    
    if (this.isPowerDown(options)) {
      return true;
    };
    if (this.isShooting(options)) {
      return true;
    };
    if (options.captureMode === 'image' &&
        options.image.exposureProgram === '2') {
        filter = options.image.auto._filter
    } else if (options.captureMode === 'video' &&
        options.video.exposureProgram === '2') {
        filter = options.video.auto._filter
    } else {
      return false;
    }
    
    if (filter !== undefined && filter === 'off') {
      return false;
    }
    return true;
  }
  
  
  render() {
    const { classes, devicename, category,error } = this.props;
    const { loading, options, value} = this.state;

    return (
        <div className="App">
        <h2>{
            typeof category !== 'undefined'?`${category.name}`:''
        }</h2>
        {(() => {
            if (error) {
                return <p className="error">{I18n.get("error")}</p>;
            } else if (typeof options === 'undefined') {
                return <p className="loading">Loading...</p>
            } else {
                return (
                <div className={classNames('plugin_base')}>
                <div className={classNames('container')}>
                <div className={classNames('page')} id="shooting_page">
                <div className={classNames('pluginctrl')}>
                <div className={classNames('pluginctrl__header')}>
                <div className={classNames('pluginctrl__header__nav')}>
                <AppBar position="static" style={{margin:'32px auto', backgroundColor: 'rgba(0, 0, 0, 0)'}} className='shooting_appbar' >
                  <Button color="inherit" onClick={this.props.handleClose} aria-label="Close" className={classNames('finishButton',classes.finish_button)}>
                    {I18n.get("finish")}
                  </Button>
                  <Toolbar className="shooting_toolbar">
                  <Tabs 
                  className='shooting_tab'
                  value={value} onChange={this.handleChange}
                  classes={{
                    indicator: classes.indicator
                  }} >
                    <Tab className="tab" disabled={this.isPowerDown(options)?true:this.isShooting(options)?true:false} label={<img src={PhotoCamera} alt="PhotoCamera" />} href="#basic-tabs" />
                    <Tab className="tab" disabled={this.isPowerDown(options)?true:this.isShooting(options)?true:false} label={<img src={Videocam} alt="Videocam" />} />
                  </Tabs>
                  </Toolbar>
                </AppBar>
                <Snackbar
                  style={{
                    margin: '200px auto'
                  }}
                  TransitionComponent={TransitionLeft}
                  open={this.isShooting(options)?true:false}
                >
                  <SnackbarContent
                    className={classes.snackbar}
                    message={options.captureMode === 'video'? I18n.get("video capturing"):I18n.get("image capturing")}
                    style={{margin: '0 auto'}}
                  />
                </Snackbar>
                <Snackbar
                  style={{
                    // margin: '200px auto'
                    margin: '300px auto'
                  }}
                  TransitionComponent={TransitionLeft}
                  open={this.isShooting(options) || this.isPowerDown(options)?false:true}
                >
                  <SnackbarContent
                    className={classes.snackbar}
                    message={I18n.get("waiting")}
                    style={{margin: '0 auto'}}
                  />
                </Snackbar>
                <Snackbar
                  style={{
                    margin: '200px auto'
                  }}
                  TransitionComponent={TransitionLeft}
                  open={this.isPowerDown(options)?true:false}
                >
                  <SnackbarContent
                    className={classes.snackbar}
                    message={I18n.get("plugin off or uploading")}
                  />
                </Snackbar>
                </div>
                </div>
                {value === 0 && <TabContainer>
                <div className={classNames('pluginctrl__shoot')} > 
                <ThetaImageMenu  disabled={this.isPowerDown(options)?true:this.isShooting(options)?true:false} devicename={devicename} options={options} updateState={this.updateState.bind(this)} />
                <div class="pluginctrl__shoot__shutter">
                <Button className={classNames('btn','btn--camera-image-white-normal')} id="camera_image_btn"></Button>
                <Button className={classNames('btn','btn--shutter-normal')} disabled={this.isPowerDown(options)?true:this.isShooting(options)?true:false} onClick={() => {this.handleClickLoading(`${devicename}`,value, null)}}>
                    Shooting
                 </Button>
                 <Button disabled={this.isActionAuto(options)?true:false} className={classNames('btn',`${options.image.exposureProgramIcon}`)} id="mode_btn" onClick={() => {this.selectClick(options.image.exposureProgramOpen)}}>
                    {`${options.image.exposureProgramTitle}`}
                 </Button>
                 </div>
                </div>
                </TabContainer>}
                {value === 1 && <TabContainer>
                <div className={classNames('pluginctrl__header')}>
                <div className={classNames('pluginctrl__header__nav')}/>
                <ThetaVideoStatusMenu  options={options} />
                </div>
                <div className={classNames('pluginctrl__shoot')}>
                <ThetaVideoMenu  disabled={this.isPowerDown(options)?true:this.isShooting(options)?true:false}  devicename={devicename} options={options} updateState={this.updateState.bind(this)} />
                <div className={classNames('pluginctrl__shoot__shutter')}>
                <button className={classNames('btn','btn--camera-image-white-normal')} id="camera_image_btn"></button>
                {loading ? 
                <Button  disabled={this.isPowerDown(options)} className={classNames('btn','btn--shutter_recording-normal')} onClick={() => {this.handleClickLoading(`${devicename}`,value, loading)}}/>
                :<Button disabled={this.isPowerDown(options)?true:this.isShooting(options)?true:false} className={classNames('btn','btn--shutte-video-normal')} onClick={() => {this.handleClickLoading(`${devicename}`,value, loading)}}/>
                }
                 <Button disabled={this.isActionAuto(options)?true:false} className={classNames('btn',`${options.video.exposureProgramIcon}`)} id="mode_btn" onClick={() => {this.selectClick(options.video.exposureProgramOpen)}}>
                    {`${options.video.exposureProgramTitle}`}
                 </Button>
                </div>
                </div>
                </TabContainer>}
                </div>
                </div>
                 {options.exposureProgramOpen && 
                 <div className={classNames('action_sheet','show')} id="setting_action">
                 <div class="btn_wrap">
                  <ThetaSlider disabled={this.isActionAuto(options)?true:false}
                    select='actions'
                    options={options}
                    devicename={devicename}
                    updateState={this.updateState.bind(this)}
                    startTimer={this.startTimer.bind(this)}
                    />
                 </div>
                 </div>
                 }
                </div>
             </div>
              );
            }
        })()}
        </div>
        );
    }
}

ThetaShooting.propTypes = {
    serialnumber: PropTypes.string,
    onMount: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    
    category: PropTypes.string,
    error: PropTypes.bool.isRequired
};

ThetaShooting.defaultProps = {
    serialnumber: '1'
};

export default withStyles(styles)(ThetaShooting);



// WEBPACK FOOTER //
// ./src/components/shooting/ThetaShooting.js